import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
  useEffect,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  TableContainer,
  Text,
} from "@chakra-ui/react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Print_pdf_adm_enq = forwardRef(({ enquiries }, ref) => {
  const printRef = useRef();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const schoolName = sessionStorage.getItem("school_name");
  const schoolEmail = sessionStorage.getItem("school_email");
  const schoolAddress = sessionStorage.getItem("school_address");
  const schoolImage = sessionStorage.getItem("school_image_url");
  useImperativeHandle(ref, () => ({
    handlePrint,
  }));

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  useEffect(() => {
    const fetchEnquiries = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${BASE_URL}/admin/admission/list_all_admission.php`
        );
        const data = await response.json();
        if (data.success) {
          enquiries(data.data);
        } else {
          setError(data.message || "Failed to load enquiries");
        }
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchEnquiries();
  }, []);

  return (
    <div
      ref={printRef}
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.5",
      }}
    >
      {/* Header with Logo */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "1px solid #e5e5e5",
          paddingBottom: "20px",
          gap: "24px",
        }}
      >
        <img
          src={schoolImage ? `${schoolImage}` : ""}
          alt={`school Logo`}
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        />

        <div>
          <h1
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "'Times New Roman', serif",
              letterSpacing: "0.5px",
            }}
          >
            {schoolName}
          </h1>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#666",
              fontFamily: "'Times New Roman', serif",
            }}
          >
            {schoolAddress}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#6C757D",
              margin: "6px 0 0",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {schoolEmail}
          </p>
        </div>
      </div>
      <h3>Admission Enquiry List</h3>

      {/* Table with Admission Enquiries Data */}
      <TableContainer>
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
          }}
          style={{
            border: "1px solid #d4c2c2",
            borderCollapse: "collapse",
            width: "100%",
          }}
        >
          <Thead>
            <Tr>
              <Th
                style={{
                  border: "1px solid #d4c2c2",
                  padding: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                S. No.
              </Th>
              {/* <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>Enquiry No.</Th> */}
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Name
              </Th>
              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Class
              </Th>

              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Phone
              </Th>

              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                Email
              </Th>

              <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                DoE
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {enquiries &&
              enquiries.map((enquiry, index) => (
                <Tr key={enquiry.id}>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {index + 1}
                  </Td>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {enquiry.name}
                  </Td>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {enquiry.class}
                  </Td>

                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {enquiry.father_no || enquiry.mother_no}
                  </Td>

                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {enquiry.email}
                  </Td>
                  <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    {new Date(enquiry.created_at).toLocaleDateString()}
                  </Td>
                  {/* <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>{new Date(enquiry.date).toLocaleDateString()}</Td> */}
                </Tr>
              ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  );
});

export default Print_pdf_adm_enq;
